<template>
  <b-row >
    <b-col sm="12">
      <b-card header="Precio">
        <div class="alert alert-primary" role="alert">
          Toda recarga de combustible será registrado con el siguiente valor de venta (por galón)
        </div>
        <form @submit.prevent="savePrice" class="form-inline">
          <div class="form-group">
            <input type="number" v-model="refueling_price.price" class="form-control mb-2 mr-sm-2" placeholder="Valor de venta" />
          </div>
          <div class="form-group">
            <input type="submit" class="btn btn-primary mb-2 mr-sm-2" value="Guardar">
          </div>
        </form>
        Precio registrado el <b>{{refueling_price.updated_at | formatDate}}</b>
      </b-card>
    </b-col>
    <b-col sm="6">
      <b-card header="Nuevo tanqueo">
        <form-fuel />
      </b-card>
    </b-col>
    <b-col sm="6">
      <b-card header="Carga masiva">
        <div class="alert alert-primary" role="alert">
          <b>Consideraciones:</b><br>
          <ul>
            <li>Debes cargar archivo .csv</li>
            <li>Descarga formato de archivo <a :href="format_file" target="_blank">aquí</a></li>
          </ul>
        </div>
        <b-form @submit.prevent="sendFile()">
          <div class="form-group">
            <input type="file" class="form-control" v-on:change="onFileChange" />
          </div>
          <div class="form-group">
            <input type="submit" value="Enviar" class="btn btn-primary" />
          </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import api from "@/helpers/api";
import FormFuel from './Form'

export default {
  components: { FormFuel },
  data() {
    return {
      format_file: `${process.env.VUE_APP_SOCKET}formatos/FORMATO_COMBUSTIBLE.csv`,
      refueling_price: { price: null },
    };
  },
  mounted() {
    api.get(`/refueling-price`).then(response => {
      this.refueling_price = response.refueling_price;
    });
  },
  methods: {
    setTruck(obj) {
      this.truck = obj ? obj : {};
    },
    savePrice(){
      
      api.put('/refueling-price', {price: this.refueling_price.price}).then(response => {
        this.refueling_price = response.refueling_price
        this.$toastr.success("Valor de venta registrado", "Proveedor", {
          positionClass: "toast-top-center",
          closeButton: true
        });
      })
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      const permitted_ext = [
        "text/comma-separated-values",
        "text/csv",
        "application/csv",
        "application/excel",
        "application/vnd.ms-excel",
        "application/vnd.msexcel"
      ];
      if (!files.length || !permitted_ext.includes(files[0].type)) {
        this.$toastr.error("Formato de archivo inválido.", "Carga masiva - Combustible", {
          positionClass: "toast-top-center",
          closeButton: true
        });
        this.file = null
      } else {
        this.file = files[0]
      }
    },
    sendFile(){

      if(this.file){
        const formData = new FormData();
        formData.append("file", this.file);

        api.post("/bulk-refueling", formData).then(response => {
          this.$toastr.success("Registros creados exitosamente", "Carga masiva - Combustible", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        }).catch(data => {
          this.$toastr.error(data.message, "Carga masiva - Combustible", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        })
      } else {
        this.$toastr.error("Debes cargar archivo válido.", "Carga masiva - Combustible", {
          positionClass: "toast-top-center",
          closeButton: true
        });
      }

    }
  }
};
</script>